import React from "react";

function getYoutubeLink(videoUrl) {
  if (videoUrl.indexOf("/watch?v=") !== -1) {
    const videoId = videoUrl.split("v=")[1];
    const ampersandPosition = videoId.indexOf("&");
    if (ampersandPosition !== -1) {
      return videoId.substring(0, ampersandPosition);
    }
    return `https://www.youtube.com/embed/${videoId}?controls=0`;
  } else if (videoUrl.indexOf("/youtu.be/") !== -1) {
    const videoId = videoUrl.split(".be/")[1];
    const ampersandPosition = videoId.indexOf("&");
    if (ampersandPosition !== -1) {
      return videoId.substring(0, ampersandPosition);
    }
    return `https://www.youtube.com/embed/${videoId}?controls=0`;
  }
  return "";
}

function YoutubeVideo(props) {
  return (
    <div>
      <iframe
        title={props.link}
        className="mt-[48px] mb-[36px] mx-[15px] w-full h-[640px] rounded-[12px]"
        src={getYoutubeLink(props.link)}
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  );
}

export default YoutubeVideo;
